<template>
    <v-simple-checkbox
        class="app-table__checkbox"
        color="primaryText"
        :value="attr.props.value"
        :ripple="false"
        :indeterminate="attr.props.indeterminate"
        @click="attr.on.input(!attr.props.value)"
    />
</template>

<script>
export default {
    name: 'HeaderDataTableSelect',
    props: {
        attr: {
            type: Object,
            default: () => ({
                props: {
                    value: false,
                    indeterminate: false
                },
                on: {
                    input: () => {}
                }
            })
        }
    }
};
</script>
